import { useMemo } from 'react';

import { Bean, ValidationRules } from '@dreryk/react-common';
import { ColorSelectorGroup, ColorValue } from '@dreryk/react-components';

import { receptionServiceTranslationKeys } from '../../../../translations';
import { ReceptionServiceFormController } from '../ReceptionServiceForm';

export type ReceptionServiceColorValue = ColorValue;

type ReceptionServiceColorSelectorGroupProps = Pick<ReceptionServiceFormController, 'register'> & {
   readonly disabled?: boolean;
};

export const ReceptionServiceColorSelectorGroup = (props: ReceptionServiceColorSelectorGroupProps): JSX.Element => {
   const validationRules = useMemo<ValidationRules<Bean>>(() => {
      return {
         required: false,
      };
   }, []);

   return (
      <ColorSelectorGroup
         testId={'color'}
         label={receptionServiceTranslationKeys.shared.form.components.colorSelectorGroup.label}
         controller={props.register('color', validationRules)}
         disabled={props.disabled}
         defaultValue={null}
      >
         <ColorSelectorGroup.TransparentColor testId={'transparent'} />
         {['2f6bb3', '159a84', '606060', '92a5b2', 'c96262', '48a267', 'bf84d3', 'e0bb36', 'b9d2ef', '7fccc0'].map(
            (hexColor) => {
               return <ColorSelectorGroup.HexColor key={hexColor} testId={hexColor} color={hexColor} />;
            }
         )}
      </ColorSelectorGroup>
   );
};
